module.exports = __webpack_public_path__ + "static/media/Nexus 9.6f0b5f39.jpg";